import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { AuthProvider } from './Contexts/AuthContext';
import AppRouter from './AppRouter';
import CONFIG from './Services/CONFIG';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
  domain={CONFIG.AUTH0_DOMAIN}
  clientId={CONFIG.AUTH0_CLIENT_ID}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: CONFIG.AUTH0_AUDIENCE,
    }}
    cacheLocation="localstorage" //need for inkognito
    // cacheLocation="memory" //default value lost every time the page is refreshed
    // useRefreshTokens={true}
  >
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  </Auth0Provider>
);
